<template lang="html">
  <div class="layout-page" :style="stylechat">
    <div v-if="status_edit === 'start'">
      <v-overlay :value="progress">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
          @click="routePage('/homepage')"
        >
          <v-icon class="fz-30">mdi-chevron-left</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title">{{$t('HeaderMenubar.profile')}}</span>
        </v-col>
        <v-col cols="2"></v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <v-layout row wrap justify-center align-start class="pt-5 pl-5 pr-5 pb-2">
        <v-avatar
          size="100"
        >
        <img v-if="data_user.profilepicture" :src="data_user.profilepicture" alt="" class="img-position">
        <img v-else-if="data_user.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
        <img v-else-if="data_user.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
        <img v-else-if="data_user.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
        <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
        </v-avatar>
      </v-layout>
      <v-layout column class="mt-4" justify-center align-center style="text-align: center;">
        <span class="text-title text-overflow">{{data_user.name}}</span>
        <span class="tab-title-status text-overflow" v-if="data_user.status">{{data_user.status}}</span>
        <span class="tab-title-status text-overflow" v-else>-</span>
      </v-layout>
      <v-layout row wrap justify-start align-start class="pt-6 pl-5 pr-5 pb-5 mt-2">
        <v-btn block class="btn-confirm text-transform" rounded @click="editProfile('edit')" :loading="loading">
          <v-icon class="mr-2">{{icon_btn}}</v-icon>
          {{$t('HeaderMenubar.editProfile')}}
        </v-btn>
      </v-layout>
      <v-divider class="ma-3"></v-divider>
      <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-2 mt-2">
        <b>{{$t('Settings.editProfile.profile')}}</b>
      </v-layout>
      <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-2 mt-2">
        <v-icon class="mr-3 icon-color">mdi-email</v-icon>
        <span class="tab-title-status text-overflow" v-if="data_user.email">{{data_user.email}}</span>
        <span class="tab-title-status text-overflow" v-else>-</span>
      </v-layout>
      <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-2 mt-2">
        <v-icon class="mr-3 icon-color">mdi-cellphone</v-icon>
        <span class="tab-title-status text-overflow" v-if="data_user.phone">{{data_user.phone}}</span>
        <span class="tab-title-status text-overflow" v-else>-</span>
      </v-layout>
      <!-- <v-layout row wrap justify-start align-start class="pt-9 pl-5 pr-5 pb-2 mt-2">
        <v-btn block class="btn-confirm text-transform" rounded @click="editProfile('edit')" :loading="loading">
          <v-icon class="mr-2">{{icon_btn}}</v-icon>
          {{$t('HeaderMenubar.editProfile')}}
        </v-btn>
      </v-layout> -->
    </div>
    <!-- status edit -->
    <div v-else-if="status_edit === 'edit'">
      <v-overlay :value="progress">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
          @click="editProfile('start')"
        >
          <v-icon class="fz-30">mdi-chevron-left</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title">{{$t('HeaderMenubar.editProfile')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
        >
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <v-layout row wrap justify-center align-start class="pt-5 pl-5 pr-5 pb-2">
        <v-badge
          avatar
          bordered
          overlap
          bottom
          offset-x="25"
          offset-y="25"
        >
          <template v-slot:badge>
            <v-avatar>
              <v-icon>mdi-camera</v-icon>
            </v-avatar>
          </template>

          <v-avatar
            size="100"
            @click="uppic"
          >
          <img v-if="data_user.profilepicture" :src="data_user.profilepicture" alt="" class="img-position">
          <img v-else-if="data_user.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
          <img v-else-if="data_user.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
          <img v-else-if="data_user.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
          <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
          </v-avatar>
          <div style="display: none;">
            <input type="file" name="profileuser"  @change="previewImageprofiles" accept="image/*" id="uploadpicprofileuser"/>
          </div>
        </v-badge>
      </v-layout>
      <v-divider class="mt-5 mr-3 ml-3 mb-3"></v-divider>
      <v-layout column justify-start align-start class="pt-2 pl-5 pr-5 pb-2">
        <span class="span-color">{{$t('Settings.editProfile.displayName')}}</span>
        <v-row @click="editInfor('edit-name')" class="pt-5 pl-3 pb-2 width-100" align="center">
          <b class="text-title-edit text-overflow">{{data_user.name}}</b>
          <v-spacer></v-spacer>
          <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
        </v-row>
      </v-layout>
      <v-layout column justify-start align-start class="pt-5 pl-5 pr-5 pb-2">
        <span class="span-color">{{$t('Settings.editProfile.status')}}</span>
        <v-row @click="editInfor('edit-status')" class="pt-5 pl-3 pb-2 width-100" align="center">
          <b class="text-title-edit text-overflow" v-if="data_user.status">{{data_user.status}}</b>
          <b class="text-title-edit text-overflow" v-else>-</b>
          <v-spacer></v-spacer>
          <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
        </v-row>
      </v-layout>
      <v-layout column justify-start align-start class="pt-5 pl-5 pr-5 pb-2">
        <span class="span-color">{{$t('Settings.editProfile.phone')}}</span>
        <!-- @click="editInfor('edit-phone')"  -->
        <v-row class="pt-5 pl-3 pb-2 width-100" align="center">
          <b class="text-title-edit text-overflow" v-if="data_user.phone">{{data_user.phone}}</b>
          <b class="text-title-edit text-overflow" v-else>-</b>
          <v-spacer></v-spacer>
          <!-- <v-icon class="icon-color-edit">mdi-chevron-right</v-icon> -->
        </v-row>
      </v-layout>
    </div>
    <!-- edit name -->
    <div v-else-if="status_edit === 'edit-name'">
      <v-overlay :value="progress">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
          @click="editProfile('edit')"
        >
          <v-icon class="fz-30">mdi-close</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title">{{$t('Settings.editProfile.displayName')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
        >
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <v-layout column justify-start align-start class="pt-2 pl-5 pr-5 pb-2">
        <span class="span-color">{{$t('Settings.editProfile.displayName')}}</span>
        <v-row class="pt-5 pl-3 width-100" align="center">
          <v-text-field
            v-model="edit_name"
            ref="displayname"
            :placeholder="$t('Settings.editProfile.displayName')"
            solo
            dense
            hide-details
          ></v-text-field>
        </v-row>
        <v-row class="pl-3 pb-2 width-100" align="center">
          <span class="span-color-err pl-1 pt-2" v-if="edit_name === ''">{{$t('Settings.messageError.UsernameRules1')}}</span>
          <v-btn @click="updateName(edit_name)" :loading="loading" class="btn-confirm mt-8" block rounded :disabled="edit_name === data_user.name || edit_name === ''">{{$t('AnswerQuestion.update')}}</v-btn>
        </v-row>
      </v-layout>
    </div>
    <!-- edit status -->
    <div v-else-if="status_edit === 'edit-status'">
      <v-overlay :value="progress">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
          @click="editProfile('edit')"
        >
          <v-icon class="fz-30">mdi-close</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title">{{$t('Settings.editProfile.status')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
        >
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <v-layout column justify-start align-start class="pt-2 pl-5 pr-5 pb-2">
        <span class="span-color">{{$t('Settings.editProfile.status')}}</span>
        <v-row class="pt-5 pl-3 width-100" align="center">
          <v-text-field
            v-model="edit_status"
            ref="displayname"
            :placeholder="$t('Settings.editProfile.status')"
            solo
            dense
            hide-details
          ></v-text-field>
        </v-row>
        <v-row class="pl-3 pb-2 width-100" align="center">
          <v-btn @click="updateStaus(edit_status)" :loading="loading" class="btn-confirm mt-8" block rounded :disabled="edit_status === data_user.status">{{$t('AnswerQuestion.update')}}</v-btn>
        </v-row>
      </v-layout>
    </div>
    <!-- edit phone -->
    <div v-else-if="status_edit === 'edit-phone'">
      <v-overlay :value="progress">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
          @click="editProfile('edit')"
        >
          <v-icon class="fz-30">mdi-close</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title">{{$t('Settings.editProfile.phone')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
        >
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <v-layout column justify-start align-start class="pt-2 pl-5 pr-5 pb-2">
        <span class="span-color">{{$t('Settings.editProfile.phone')}}</span>
        <v-row class="pt-5 pl-3 width-100" align="center">
          <v-text-field
            v-model="edit_phone"
            ref="displayname"
            :placeholder="$t('Settings.editProfile.phone')"
            solo
            dense
            hide-details
            type="number"
          ></v-text-field>
        </v-row>
        <v-row class="pl-3 pb-2 width-100" align="center">
          <span class="span-color-err pl-1 pt-2" v-if="edit_phone === ''">{{$t('Homepage.Dialog.inputphoneErrorDigit')}}</span>
          <v-btn @click="updatePhone(edit_phone)" :loading="loading" class="btn-confirm mt-8" block rounded :disabled="edit_phone === data_user.phone || edit_phone === ''">{{$t('AnswerQuestion.update')}}</v-btn>
        </v-row>
      </v-layout>
    </div>
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import ErrorDialog from '@/components/Alert/Error'
import Warning from '@/components/Alert/Warning'
export default {
  data () {
    return {
      publicPath: process.env.VUE_APP_BASE_PATH,
      rules: {
        required: value => !!value || this.$t('Homepage.Dialog.inputphoneErrorDigit'),
        counter: value => value.length <= 10 || this.$t('Homepage.Dialog.inputphoneErrorDigit'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      WarningDialog: false,
      WarningDialogDetail: {},
      status_edit: 'start',
      icon_btn: '',
      loading: false,
      ErrorDialogDetail: {},
      ErrorDialog: false,
      relation: '',
      text_btn: '',
      progress: false,
      data_user: {},
      data_user: {},
      stylechat: {
        "--ProfileFriend-HeaderColor": "white",
        "--ProfileFriend-TabBackground": "white",
        "--ProfileFriend-Icon": "gray",
        "--ProfileFriend-IconActive": "#2662ae",
        "--ProfileFriend-Background": "white",
        "--ProfileFriend-FontSize": "18px",
        "--ProfileFriend-FontSize-Title": "24px",
        "--ProfileFriend-FontSize-Title-Edit": "20px",
        "--ProfileFriend-FontColor": "back",
        "--ProfileFriend-FontColor-Err": "#ff5252",
        "--ProfileFriend-FontSize-Status": "16px",
        "--ProfileFriend-FontColor-Status": "grey",
        "--ProfileFriend-Background-Input": "#E2E1E3",
        "--ProfileFriend-Color-Button": "#EFF2FE",
        "--ProfileFriend-FontColor-Button": "#2662ae",
        "--ProfileFriend-FontColor-Block-Button": "#cb1002",
        "--ProfileFriend-FontColor-Dis-Button": "#e2e1e3",
        "--ProfileFriend-Btn-Confirm-Background": "#2662ae",
        "--ProfileFriend-Btn-Confirm-Color": "white",
        "--ProfileFriend-Btn-Confirm-FontSize": "18px",
      },
      selectFile: '',
      edit_name: '',
      edit_status: '',
      edit_phone: '',
    }
  },
  computed: {
    ...sync('*')
  },
  components: {
    ErrorDialog,
    Warning
  },
  created () {
    // console.log('themechat group', this.themechat)
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    // console.log(user_profile)
    this.data_user = user_profile['account']['profile']
    this.edit_name = this.data_user.name
    this.edit_status = this.data_user.status
    this.edit_phone = this.data_user.phone
    // console.log(this.data_user)
    // this.getUser(this.$route.params.tokenuser)
  },
  methods: {
    emitWarning (data) {
      // console.log(data)
      this.WarningDialog = false
      if (data.detail === 'confirm') {
        this.status_edit = 'edit-phone'
      } else {
        this.status_edit = 'edit'
      }
    },
    updatePhone (phone) {
      this.loading = true
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/check_phone_login', {
        phone: phone
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.loading = false
          this.progress = false
          if(response.data.message === 'non registered') {
            localStorage.typeAccount = true
          } else if (response.data.message === 'registered') {
            localStorage.typeAccount = false
          }
          localStorage.phonRecent = this.data_user.phone
          localStorage.phoneEdit = phone
          this.$router.push('/profile/editphone')
        }
      }).catch(err => {
        this.loading = false
        this.progress = false
        console.log(err)
      })
    },
    updateStaus (status) {
      this.loading = true
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/setstatususer',
        {
          tokenuser: this.data_user.tokenuser,
          status: status
        }).then((response) => {
        if (response.data.status === 'success') {
          this.data_user.status = status
          var user_profile = JSON.parse(this.$cookie.get('user-profile'))
          user_profile['account']['profile']['status'] = status
          this.$cookie.set('user-profile', JSON.stringify(user_profile))
          this.loading = false
          this.progress = false
          this.status_edit = 'edit'
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    updateName (name) {
      this.loading = true
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/setnameuser',
        {
          tokenuser: this.data_user.tokenuser,
          name: name,
          business_id: null,
          type_user: 'user'
        }).then((response) => {
        if (response.data.status === 'success') {
          this.data_user.name = name
          this.data_user.nickname = name
          var user_profile = JSON.parse(this.$cookie.get('user-profile'))
          user_profile['account']['profile']['name'] = name
          this.$cookie.set('user-profile', JSON.stringify(user_profile))
          this.loading = false
          this.progress = false
          this.status_edit = 'edit'
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    editInfor (type) {
      // console.log(type)
      if (type === 'edit-phone') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Settings.messageEditPhone.ChangePhoneNumber'),
          detail: 'confirm',
          index: 0
        }
        this.WarningDialog = true
      } else {
        this.status_edit = type
      }
    },
    uppic () {
      document.getElementById('uploadpicprofileuser').click()
    },
    previewImageprofiles (data) {
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenuser', this.data_user.tokenuser)
      uploadFile.append('business_id', null)
      uploadFile.append('type_user', 'user')
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/setpictureprofileuser', uploadFile).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.data_user.profilepicture = response.data.filename
          var user_profile = JSON.parse(this.$cookie.get('user-profile'))
          user_profile['account']['profile']['profilepicture'] = response.data.filename
          this.$cookie.set('user-profile', JSON.stringify(user_profile))
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    editProfile (status) {
      this.status_edit = status
      this.edit_name = this.data_user.name
      this.edit_status = this.data_user.status
      this.edit_phone = this.data_user.phone
    },
    closeAlertDialog (item) {
      if (item.type === 'err') {
        this.ErrorDialog = false
      } else if (item.type === 'warning') {
        this.WarningDialog = false
      }
    },
    routePage (path) {
      this.$router.push(path)
    },
    getUser (tokenfriend) {
      // console.log(tokenfriend)
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/searchtokenuser`, {
        tokenuser: this.data_user.tokenuser,
        tokenfriend: tokenfriend
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.data_user = response.data['user']
          this.relation = response.data.relation
          if (this.relation === 'friend') {
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon_btn = 'fa-solid fa-comment-dots'
          } else if (this.relation === 'request') {
            this.text_btn = this.$t('AnswerQuestion.acceptFriend')
            this.icon_btn = 'mdi-account-plus'
          } else if (this.relation === 'sendrequest') {
            this.text_btn = this.$t('AnswerQuestion.cancelRequest')
            this.icon_btn = 'mdi-account-minus'
          } else if (this.relation === 'block') {
            this.text_btn = this.$t('AnswerQuestion.unblock')
            this.icon_btn = 'mdi-lock-open'
          } else if (this.relation === 'unknown') {
            this.text_btn = this.$t('AnswerQuestion.addFriend')
            this.icon_btn = 'mdi-account-plus'
          } else {
            this.text_btn = this.$t('AnswerQuestion.ok')
            this.icon_btn = 'mdi-account-circle'
          }
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
      })
    },
    checkState (relation) {
      if (relation === 'friend') {
        this.$router.push(`/chat/${this.data_user.tokenroom}`)
      } else if (relation === 'sendrequest') {
        // ยกเลิกคำขอเป็นเพื่อน
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + `/removerequestfriend`, {
          tokenfriend: this.data_user.tokenuser,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.relation = 'unknown'
            this.text_btn = this.$t('AnswerQuestion.addFriend')
            this.icon_btn = 'mdi-account-plus'
          } else {
            this.loading = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else if (relation === 'request') {
        // ตอบรับคำขอเป็นเพื่อน
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/accept-friend`, {
          tokenfriend: this.data_user.tokenuser,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon_btn = 'fa-solid fa-comment-dots'
            this.relation = 'friend'
            this.data_user.tokenroom = response.data.tokenroom
          } else {
            this.loading = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else if (relation === 'block') {
        // unblock
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + `/unblockfriend`, {
          tokenuser: this.data_user.tokenuser,
          tokenfriend: this.data_user.tokenuser,
          tokenroom: this.data_user.tokenroom
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.relation = 'friend'
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon_btn = 'fa-solid fa-comment-dots'
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else if (relation === 'unknown') {
        // add collap
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/add-friend-accept`, {
          tokenuser: this.data_user.tokenuser,
          tokenfriend: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon_btn = 'fa-solid fa-comment-dots'
            this.relation = 'friend'
            this.data_user.tokenroom = response.data.tokenroom
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
.span-color-err {
  color: var(--ProfileFriend-FontColor-Err) !important;
}
 >>>.v-input__slot {
  background-color: var(--ProfileFriend-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
.width-100 {
  width: 100% !important;
}
.span-color {
  color: var(--ProfileFriend-FontColor-Status) !important;
}
.icon-color {
  color: var(--ProfileFriend-IconActive) !important;
}
.icon-color-edit {
  color: var(--ProfileFriend-Icon) !important;
}
.btn-confirm {
  background-color: var(--ProfileFriend-Btn-Confirm-Background) !important;
  color: var(--ProfileFriend-Btn-Confirm-Color) !important;
  font-size: var(--ProfileFriend-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--ProfileFriend-Background) !important;
}
.fz-30 {
  font-size: 30px;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--ProfileFriend-FontSize-Title) !important;
  color: var(--ProfileFriend-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--ProfileFriend-FontSize-Title-Edit) !important;
  color: var(--ProfileFriend-FontColor) !important;
}
.tab-title {
  color: var(--ProfileFriend-FontColor) !important;
  font-size: var(--ProfileFriend-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--ProfileFriend-FontColor-Status) !important;
  font-size: var(--ProfileFriend-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
